import React, { useEffect } from 'react';
import { connect } from 'react-redux';
// constants
import { highSpeedVerification } from '@fttb/common/constants';
import { useFetchStreet } from "../../../../hooks/useFetchStreet";
import { setFlat } from "../../../../store/actions/common";
import { setLoading, setNextStep } from "../../../../store/reducers/slice";
import { fetchCheckConnection } from "../../../../store/actions/handleCheckConnection";
import { getAddressData, getIsPresetUpFlag, selectRegion } from "../../../../store/selectors/orderTariffCommon";
import { useFetchHouse } from "../../../../hooks/useFetchHouse";
import { AddressForm } from "./components";
import { setFlatWithYm, setHouseWithYm, setStatusConnectionWithYm, setStreetWithYm } from "../../../../store/actions/withAnalytics";
import { setAddressDataFromYams } from "../../../../store/actions/initAddressFromYams";
import { useAddressVerification } from "../../../../hooks/useAddressVerification";
var AddressRequestInputsSection = function AddressRequestInputsSection(_ref) {
  var flat = _ref.flat,
    house = _ref.house,
    initAddressFromYams = _ref.initAddressFromYams,
    isConvergentRequest = _ref.isConvergentRequest,
    region = _ref.region,
    setAddressChecked = _ref.setAddressChecked,
    setChosenFlat = _ref.setChosenFlat,
    setChosenHouse = _ref.setChosenHouse,
    setChosenStreet = _ref.setChosenStreet,
    setFocusFlat = _ref.setFocusFlat,
    setIsLoading = _ref.setIsLoading,
    street = _ref.street,
    texts = _ref.texts,
    checkConnection = _ref.checkConnection;
  useEffect(function () {
    initAddressFromYams();
  }, []);
  var _useFetchHouse = useFetchHouse({
      setChosenHouse: setChosenHouse,
      street: street,
      setAddressChecked: setAddressChecked
    }),
    fetchHouses = _useFetchHouse.fetchHouses,
    onSelectHouseFromList = _useFetchHouse.onSelectHouseFromList;
  var _useFetchStreet = useFetchStreet({
      setChosenStreet: setChosenStreet,
      region: region,
      setAddressChecked: setAddressChecked
    }),
    fetchStreets = _useFetchStreet.fetchStreets,
    onSelectStreetFromList = _useFetchStreet.onSelectStreetFromList;
  useAddressVerification({
    checkAddressType: highSpeedVerification.withVerification,
    flat: flat,
    house: house,
    isConvergentRequest: isConvergentRequest,
    region: region,
    setLoading: setIsLoading,
    street: street,
    // @ts-expect-error fixme later
    checkConnection: checkConnection
  });
  return /*#__PURE__*/React.createElement(AddressForm, {
    fetchHouses: fetchHouses,
    fetchStreets: fetchStreets,
    flat: flat,
    house: house,
    onSelectHouseFromList: onSelectHouseFromList,
    onSelectStreetFromList: onSelectStreetFromList,
    region: region === null || region === void 0 ? void 0 : region.label,
    setAddressChecked: setAddressChecked,
    setFocusFlat: setFocusFlat,
    setSelectedFlat: setChosenFlat,
    setSelectedHouse: setChosenHouse,
    setSelectedStreet: setChosenStreet,
    street: street,
    texts: texts,
    "data-t-id": "AddressRequestForm-AddressRequestInputsSection"
  });
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    ctn: getAddressData(state).userPhoneNumber,
    flat: getAddressData(state).flat,
    house: getAddressData(state).house,
    isConvergentRequest: getIsPresetUpFlag(state),
    region: selectRegion(state),
    street: getAddressData(state).street
  };
};
var mapDispatchToProps = {
  initAddressFromYams: setAddressDataFromYams,
  setAddressChecked: setStatusConnectionWithYm,
  setChosenFlat: setFlat,
  setChosenHouse: setHouseWithYm,
  setChosenStreet: setStreetWithYm,
  setFocusFlat: setFlatWithYm,
  setIsLoading: setLoading,
  setStep: setNextStep,
  checkConnection: fetchCheckConnection
};
var connector = connect(mapStateToProps, mapDispatchToProps);
var AddressRequestInputsSectionWithStore = connector(AddressRequestInputsSection);
export { AddressRequestInputsSectionWithStore as AddressRequestInputsSection };